/**
 * Меню библиотеки компонентов
 * */
export const componentsMenu = [
	{
		id: 'overview',
		name: 'Overview',
		icon: '📋',
		section: 'Getting Started'
	},
	{
		id: 'inputs',
		name: 'Input Fields',
		icon: '📝',
		section: 'Form Components'
	},
	{
		id: 'checkboxes',
		name: 'Checkboxes',
		icon: '☑️',
		section: 'Form Components'
	},
	{
		id: 'buttons',
		name: 'Buttons',
		icon: '🔘',
		section: 'Actions'
	},
	{
		id: 'confirm-dialog',
		name: 'Confirm Dialog',
		icon: '🗑️',
		section: 'Actions'
	},
	{
		id: 'toggles',
		name: 'Toggles & Switches',
		icon: '🔄',
		section: 'Interactions'
	},
	{
		id: 'select',
		name: 'Select',
		icon: '📌',
		section: 'Dropdowns'
	},
	{
		id: 'tabs',
		name: 'Tabs',
		icon: '📑',
		section: 'Navigation'
	},
	{
		id: 'card',
		name: 'Card',
		icon: '🎴',
		section: 'Containers'
	},
	{
		id: 'icon',
		name: 'Icon',
		icon: '🎨',
		section: 'Media'
	},
	{
		id: 'new-data-grid-lvl1',
		name: 'new-data-grid-lvl1',
		icon: '🎨',
		section: 'new-data-grid-lvl1'
	},
	{
		id: 'new-data-grid-lvl2',
		name: 'new-data-grid-lvl2',
		icon: '🎨',
		section: 'new-data-grid-lvl2'
	}
];
